module.exports = require('../abstract').extend
  template: require('./index.pug')

  methods:

    updateValue: (value) ->
      # formattedValue = value.trim()
      #
      # @.$refs.input.value = formattedValue if formattedValue != value
      #
      # @.$emit('input', formattedValue)
      @.$emit('input', value)




// WEBPACK FOOTER //
// ./assets/js/frontend/components/form/input/index.coffee